<template>
  <div>
    <vs-table :data="icons">
      <template slot="header">
        <h3>
          All Supported Icons
        </h3>
        Steps to import icons:
        <ul>
          <li>go to https://icomoon.io/</li>
          <li>import project using ./speakol-font-icomoon.json</li>
          <li>load the project</li>
          <li>in speakol set group click options button then import to set</li>
          <li>select your svg icons</li>
          <li>edit the icons (edit from top action bar) to have no colors</li>
          <li>make sure icons displayed correctly in download fonts tab</li>
          <li>select the new icons to be highlighted (include in the set) using select action from top menu</li>
          <li>generate fonts, replace files in fonts folder with generated one</li>
          <li>add the new icons to this page, add its css as "content: "\e947";" in speakol.css</li>
          <li>icomoon download the project and replace content of ./speakol-font-icomoon.json with new json</li>
        </ul>
      </template>
      <template slot="thead">
        <vs-th>
          #
        </vs-th>
        <vs-th sort-key="icon">
          vs-icon
        </vs-th>
        <vs-th>
          span
        </vs-th>
        <vs-th>
          name
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(_, indextr) in data">
          <vs-td :data="indextr + 1">
            {{ indextr + 1 }}
          </vs-td>
          <vs-td :data="data[indextr].icon">
            <vs-icon style="font-size: 25px;" :icon="`speakol-${data[indextr].icon}`" icon-pack="speakol"></vs-icon>
          </vs-td>
          <vs-td :data="data[indextr].icon">
            <span style="font-size: 25px;" class="speakol" :class="`speakol-${data[indextr].icon}`"></span>
          </vs-td>
          <vs-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      amount: 0,
      icons: [
        {
          icon: 'reorder',
          name: 'speakol-reorder'
        },
        {
          icon: 'short-answer',
          name: 'speakol-short-answer'
        },
        {
          icon: 'multiple-choice',
          name: 'speakol-multiple-choice'
        },
        {
          icon: 'info-2',
          name: 'speakol-info-2'
        },
        {
          icon: 'warning-2',
          name: 'speakol-warning-2'
        },
        {
          icon: 'warning-fill',
          name: 'speakol-warning-fill'
        },
        {
          icon: 'activity',
          name: 'speakol-activity'
        },
        {
          icon: 'trending',
          name: 'speakol-trending'
        },
        {
          icon: 'settings-2',
          name: 'speakol-settings-2'
        },
        {
          icon: 'map-pin',
          name: 'speakol-map-pin'
        },
        {
          icon: 'alert-circle',
          name: 'speakol-alert-circle'
        },
        {
          icon: 'chevron-up',
          name: 'speakol-chevron-up'
        },
        {
          icon: 'code',
          name: 'speakol-code'
        },
        {
          icon: 'more-horizontal',
          name: 'speakol-more-horizontal'
        },
        {
          icon: 'menu',
          name: 'speakol-menu'
        },
        {
          icon: 'circle',
          name: 'speakol-circle'
        },
        {
          icon: 'conversions',
          name: 'speakol-conversions'
        },
        {
          icon: 'avaliable-balance',
          name: 'speakol-avaliable-balance'
        },
        {
          icon: 'bouns',
          name: 'speakol-bouns'
        },
        {
          icon: 'refund',
          name: 'speakol-refund'
        },
        {
          icon: 'spent',
          name: 'speakol-spent'
        },
        {
          icon: 'total-fund',
          name: 'speakol-total-fund'
        },
        {
          icon: 'transfer',
          name: 'speakol-transfer'
        },
        {
          icon: 'vat',
          name: 'speakol-vat'
        },
        {
          icon: 'delete',
          name: 'speakol-delete'
        },
        {
          icon: 'verify',
          name: 'speakol-verify'
        },
        {
          icon: 'unverify',
          name: 'speakol-unverify'
        },
        {
          icon: 'bonus',
          name: 'speakol-bonus'
        },
        {
          icon: 'help-3',
          name: 'speakol-help-3'
        },
        {
          icon: 'right-arrow',
          name: 'speakol-right-arrow'
        },
        {
          icon: 'email',
          name: 'speakol-email'
        },
        {
          icon: 'call',
          name: 'speakol-call'
        },
        {
          icon: 'locked',
          name: 'speakol-locked'
        },
        {
          icon: 'Vector-6',
          name: 'speakol-Vector-6'
        },
        {
          icon: 'dollar',
          name: 'speakol-dollar'
        },
        {
          icon: 'message',
          name: 'speakol-message'
        },
        {
          icon: 'building',
          name: 'speakol-building'
        },
        {
          icon: 'premium-solid',
          name: 'speakol-premium-solid'
        },
        {
          icon: 'premium',
          name: 'speakol-premium'
        },
        {
          icon: 'verified',
          name: 'speakol-verified'
        },
        {
          icon: 'star',
          name: 'speakol-star'
        },
        {
          icon: 'star-solid',
          name: 'speakol-star-solid'
        },
        {
          icon: 'no-horn',
          name: 'speakol-no-horn'
        },
        {
          icon: 'filters',
          name: 'speakol-filters'
        },
        {
          icon: 'mobile-2',
          name: 'speakol-mobile-2'
        },
        {
          icon: 'mobile-3',
          name: 'speakol-mobile-3'
        },
        {
          icon: 'tablet-2',
          name: 'speakol-tablet-2'
        },
        {
          icon: 'ads',
          name: 'speakol-ads'
        },
        {
          icon: 'targeting',
          name: 'speakol-targeting'
        },
        {
          icon: 'www',
          name: 'speakol-www'
        },
        {
          icon: 'help',
          name: 'speakol-help'
        },
        {
          icon: 'accounts',
          name: 'speakol-accounts'
        },
        {
          icon: 'features',
          name: 'speakol-features'
        },
        {
          icon: 'fund',
          name: 'speakol-fund'
        },
        {
          icon: 'min-bid',
          name: 'speakol-min-bid'
        },
        {
          icon: 'report',
          name: 'speakol-report'
        },
        {
          icon: 'users',
          name: 'speakol-users'
        },
        {
          icon: 'pause-2',
          name: 'speakol-pause-2'
        },
        {
          icon: 'logo',
          name: 'speakol-logo'
        },
        {
          icon: 'finger-click',
          name: 'speakol-finger-click'
        },
        {
          icon: 'percentage-sign',
          name: 'speakol-percentage-sign'
        },
        {
          icon: 'active',
          name: 'speakol-active'
        },
        {
          icon: 'copy',
          name: 'speakol-copy'
        },
        {
          icon: 'download',
          name: 'speakol-download'
        },
        {
          icon: 'fund',
          name: 'speakol-fund'
        },
        {
          icon: 'pause',
          name: 'speakol-pause'
        },
        {
          icon: 'rejected',
          name: 'speakol-rejected'
        },
        {
          icon: 'resume',
          name: 'speakol-resume'
        },
        {
          icon: 'schedule',
          name: 'speakol-schedule'
        },
        {
          icon: 'start',
          name: 'speakol-start'
        },
        {
          icon: 'return',
          name: 'speakol-return'
        },
        {
          icon: 'plus',
          name: 'speakol-plus'
        },
        {
          icon: 'add',
          name: 'speakol-add'
        },
        {
          icon: 'arrow-right',
          name: 'speakol-arrow-right'
        },
        {
          icon: 'audience',
          name: 'speakol-audience'
        },
        {
          icon: 'campaigns',
          name: 'speakol-campaigns'
        },
        {
          icon: 'create-campaign',
          name: 'speakol-create-campaign'
        },
        {
          icon: 'calendar',
          name: 'speakol-calendar'
        },
        {
          icon: 'desktop',
          name: 'speakol-desktop'
        },
        {
          icon: 'dots',
          name: 'speakol-dots'
        },
        {
          icon: 'duplicate',
          name: 'speakol-duplicate'
        },
        {
          icon: 'money',
          name: 'speakol-money'
        },
        {
          icon: 'bill',
          name: 'speakol-bill'
        },
        {
          icon: 'person',
          name: 'speakol-person'
        },
        {
          icon: 'add-user',
          name: 'speakol-add-user'
        },
        {
          icon: 'add-circle',
          name: 'speakol-add-circle'
        },
        {
          icon: 'administrator',
          name: 'speakol-administrator'
        },
        {
          icon: 'fork',
          name: 'speakol-fork'
        },
        {
          icon: 'chat',
          name: 'speakol-chat'
        },
        {
          icon: 'contact-us',
          name: 'speakol-contact-us'
        },
        {
          icon: 'credit-card',
          name: 'speakol-credit-card'
        },
        {
          icon: 'data-protection',
          name: 'speakol-data-protection'
        },
        {
          icon: 'data-provider',
          name: 'speakol-data-provider'
        },
        {
          icon: 'dot-rounded',
          name: 'speakol-dot-rounded'
        },
        {
          icon: 'download-graph-report',
          name: 'speakol-download-graph-report'
        },
        {
          icon: 'edit',
          name: 'speakol-edit'
        },
        {
          icon: 'eye',
          name: 'speakol-eye'
        },
        {
          icon: 'hide',
          name: 'speakol-hide'
        },
        {
          icon: 'home',
          name: 'speakol-home'
        },
        {
          icon: 'location',
          name: 'speakol-location'
        },
        {
          icon: 'login',
          name: 'speakol-login'
        },
        {
          icon: 'network',
          name: 'speakol-network'
        },
        {
          icon: 'envelope',
          name: 'speakol-envelope'
        },
        {
          icon: 'ok',
          name: 'speakol-ok'
        },
        {
          icon: 'password',
          name: 'speakol-password'
        },
        {
          icon: 'people',
          name: 'speakol-people'
        },
        {
          icon: 'phone',
          name: 'speakol-phone'
        },
        {
          icon: 'settings',
          name: 'speakol-settings'
        },
        {
          icon: 'unavailable',
          name: 'speakol-unavailable'
        },
        {
          icon: 'user-account',
          name: 'speakol-user-account'
        },
        {
          icon: 'logout',
          name: 'speakol-logout'
        },
        {
          icon: 'mobile',
          name: 'speakol-mobile'
        },
        {
          icon: 'play',
          name: 'speakol-play'
        },
        {
          icon: 'question',
          name: 'speakol-question'
        },
        {
          icon: 'remove',
          name: 'speakol-remove'
        },
        {
          icon: 'horn',
          name: 'speakol-horn'
        },
        {
          icon: 'shape',
          name: 'speakol-shape'
        },
        {
          icon: 'tablet',
          name: 'speakol-tablet'
        },
        {
          icon: 'upload-solid',
          name: 'speakol-upload-solid'
        },
        {
          icon: 'upload',
          name: 'speakol-upload'
        },
        {
          icon: 'warning',
          name: 'speakol-warning'
        },
        {
          icon: 'cancel',
          name: 'speakol-cancel'
        },
        {
          icon: 'error',
          name: 'speakol-error'
        },
        {
          icon: 'info',
          name: 'speakol-info'
        },
        {
          icon: 'save',
          name: 'speakol-save'
        },
        {
          icon: 'arrow-down',
          name: 'speakol-arrow-down'
        },
        {
          icon: 'double-arrow-right',
          name: 'speakol-double-arrow-right'
        },
        {
          icon: 'arrow-down-2',
          name: 'speakol-arrow-down-2'
        },
        {
          icon: 'search',
          name: 'speakol-search'
        },
        {
          icon: 'us-dollar',
          name: 'speakol-us-dollar'
        },
        {
          icon: 'fund-accounting',
          name: 'speakol-fund-accounting'
        },
        {
          icon: 'transaction',
          name: 'speakol-transaction'
        }
      ]
    }
  }
}
</script>

